export default function dateFieldOptions(dateOrTimeType, fields) {
  return  fields
          .filter(({ data_type }) => (data_type === dateOrTimeType))
          .map(({ name, id }) => ({ text: name, value: id }));
}
